import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  skill: [{
    label: 'HSK 1',
    level: 1,
    value: 'hsk1',
    languageId: 2
  }, {
    label: 'HSK 2',
    level: 2,
    value: 'hsk2',
    languageId: 2
  }, {
    label: 'HSK 3',
    level: 3,
    value: 'hsk3',
    languageId: 2
  }, {
    label: 'HSK 4',
    level: 4,
    value: 'hsk4',
    languageId: 2
  }, {
    label: 'HSK 5',
    level: 5,
    value: 'hsk5',
    languageId: 2
  }, {
    label: 'HSK 6',
    level: 6,
    value: 'hsk6',
    languageId: 2
  }, {
    label: 'HSK 7',
    level: 7,
    value: 'hsk7',
    languageId: 2
  }, {
    label: 'HSK 8',
    level: 8,
    value: 'hsk8',
    languageId: 2
  }, {
    label: 'HSK 9',
    level: 9,
    value: 'hsk9',
    languageId: 2
  }],
  cats: [],
  skillSelected: 0
};
const skillSettingsSlice = createSlice({
  name: 'skillSettings',
  initialState,
  reducers: {
    setSkillSettings: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    setSkill: (state, action) => {
      state.skill = action.payload;
    },
    setCats: (state, action) => {
      state.cats = action.payload;
    },
    setSkillSelected: (state, action) => {
      state.skillSelected = action.payload;
    },
    resetSkillSettings: () => initialState
  },
  extraReducers: builder => {
    builder.addCase('settingsSyncSuccess', (state, action) => {
      if (action.payload) {
        const {
          skill,
          cats,
          skillSelected
        } = action.payload;
        return {
          ...state,
          ...(skill !== undefined && {
            skill
          }),
          ...(cats !== undefined && {
            cats
          }),
          ...(skillSelected !== undefined && {
            skillSelected
          })
        };
      }
      return state;
    });
  }
});
export const {
  setSkillSettings,
  setSkill,
  setCats,
  setSkillSelected,
  resetSkillSettings
} = skillSettingsSlice.actions;
export default skillSettingsSlice.reducer;